<template>
  <BaseButton
    class="btn-transparent"
    @click="$emit('click', $event)"
  >
    <span class="btn-transparent__text">{{ text }}</span>
    <SvgAsset
      v-if="image"
      class="btn-transparent__icon"
      :content="image"
    />
  </BaseButton>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BaseButton from '~/components/BaseComponents/BaseButton.vue';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';

  export default defineNuxtComponent({
    name: 'BaseButtonTransparent',
    components: {
      BaseButton,
      SvgAsset,
    },

    props: {
      text: {
        default: '',
        type: String as PropType<string>,
      },

      image: {
        default: '',
        type: String as PropType<string>,
      },
    },

    emits: ['click'],
  });
</script>

<style lang="scss" scoped>
  .btn-transparent {
    padding: $spacing-2 $spacing-13;
    border-radius: 24px;
    width: 100%;
    background-color: transparent;

    color: $default-color--1;
    border: 1px solid $default-color--1;
    font-weight: 500;
    @include normalText;
    display: flex;
    align-items: center;
    justify-content: center;

    &__icon {
      margin-left: $spacing-1;
      width: 16px;
      height: 16px;
      :deep() {
        svg path {
          stroke: $default-color--1;
        }
      }
      flex-shrink: 0;
    }
    @include hover {
      color: $hover-color--2;
      border: 1px solid $hover-color--2;
      .btn-transparent__icon {
        :deep() {
          svg path {
            stroke: $hover-color--2;
          }
        }
      }
    }
  }
</style>
